import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { getDailyInterviews } from "../../helpers/backend_helper";
import {
  fetchUpcomingInterviewsRequest,
  fetchUpcomingInterviewsSuccess,
  fetchUpcomingInterviewsFailure,
} from "./action";

import { FETCH_UPCOMING_INTERVIEWS_REQUEST } from "./actionType";

function* fetchDailyInterviewsSaga(action) {
  try {
    const response = yield call(getDailyInterviews, {
      upcomingInterviewDate: action.payload,
    });
    yield put(fetchUpcomingInterviewsSuccess(response));
  } catch (error) {
    yield put(fetchUpcomingInterviewsFailure(error.message));
  }
}

export default function* watchFetchDailyInterviewsSaga() {
  yield takeLatest(FETCH_UPCOMING_INTERVIEWS_REQUEST, fetchDailyInterviewsSaga);
}
